import { Middleware, configureStore, combineReducers } from '@reduxjs/toolkit';

import { userApi } from './api/user';
import { authApi } from './api/auth';
import { formsApi } from './api/forms';
import { tenantApi } from './api/tenant';
import { coursesApi } from './api/courses';
import { projectsApi } from './api/project';
import { childrenApi } from './api/children';
import { resourcesApi } from './api/resources';
import { libraryTagsApi } from './api/library';
import { loaderReducer } from './slices/loader';
import { pdfReportsApi } from './api/pdf-reports';
import { types, authReducer } from './slices/auth';
import { replicationApi } from './api/replication';
import { courseStepsApi } from './api/course-steps';
import { gameAnalyticsApi } from './api/game-analytics';
import { pdfReportLogsApi } from './api/pdf-report-logs';
import { reportTemplatesApi } from './api/report-templates';
import { userAuditEventsApi } from './api/user-audit-events';
import { libraryResourcesApi } from './api/library-resources';
import { courseSubmissionsApi } from './api/course-submissions';

const apis = [
  authApi,
  userApi,
  formsApi,
  tenantApi,
  coursesApi,
  projectsApi,
  childrenApi,
  resourcesApi,
  pdfReportsApi,
  courseStepsApi,
  libraryTagsApi,
  replicationApi,
  gameAnalyticsApi,
  pdfReportLogsApi,
  userAuditEventsApi,
  reportTemplatesApi,
  libraryResourcesApi,
  courseSubmissionsApi,
];

const appReducer = combineReducers({
  ...Object.fromEntries(apis.map((api) => [api.reducerPath, api.reducer])),
  auth: authReducer,
  loader: loaderReducer,
});

export const resetApiState = (dispatch: any) => {
  apis.forEach((api) => dispatch(api.util.resetApiState()));
};

const rootReducer = (state: any, action: any) => {
  if (action.type === types.logout) {
    return appReducer(undefined, action);
  }
  return appReducer(state, action);
};

const middlewares: Middleware[] = apis.map((api) => api.middleware);

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(middlewares),
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;
